import React from 'react';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

function Wrapper({ children }) {
  const { selectedCourse } = React.useContext(DataContext);

  return <MyWrapper selected={selectedCourse}>{children}</MyWrapper>;
}

export default Wrapper;

const MyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${({ selected }) => (selected ? 'black' : 'white')};
`;
